export default __webpack_public_path__ + "static/media/fc-3.576b8f1e.png";